import type { RecordingSpeakerRoleType } from "@repo/app-types/entities/recording";
import type { FC, ReactNode } from "react";
import { useAudioPlayerTrigger } from "../audioPlayer/useAudioPlayerTrigger.js";
import { TranscriptMessage } from "./transcriptMessage.js";

export interface PlayableTranscriptMessageProps {
  /** The audio player source this message belongs to. */
  sourceKey: string;
  /** The start time of this message, in seconds. */
  time: number;
  /** The start time of the next message, in seconds. */
  nextTime: number | undefined;
  speakerName: string;
  speakerRole?: RecordingSpeakerRoleType | undefined;
  children: ReactNode;
}

/** A transcript message wired to the audio player. */
export const PlayableTranscriptMessage: FC<PlayableTranscriptMessageProps> = (
  props,
) => {
  const { sourceKey, time, nextTime, speakerName, speakerRole, children } =
    props;
  const { isCurrent, isPlaying, play, pause } = useAudioPlayerTrigger({
    sourceKey,
    time,
    nextTime,
  });

  return (
    <TranscriptMessage
      speakerName={speakerName}
      speakerRole={speakerRole}
      playback={{ time, isCurrent, isPlaying, onPlay: play, onPause: pause }}
    >
      {children}
    </TranscriptMessage>
  );
};
